import { IApWorkflowResponse } from "../interfaces/ap-workflow";
import authBaseAxios from "../utils/api";
// import { IEspResponse, IEspTable, IEspTableDataResponse } from "../interfaces/expect-supplier-payment";
import qs from "qs";

export const ApWorkflowService = {
  getAllAndRow: (params: any): Promise<IApWorkflowResponse> => {
    const queryString = qs.stringify(params, { arrayFormat: "repeat" });
    return authBaseAxios.get(`ap-workflow?${queryString}`);
  },

  checkTabReview: (id: string, params: any): Promise<any> => {
    const queryString = qs.stringify(params, { arrayFormat: "repeat" });
    return authBaseAxios.get(`ap-workflow/${id}/review?${queryString}`);
  },

  changeStatus: (ids: any[], status: string, isForce: boolean = false, tab?: string): Promise<any> => {
    return authBaseAxios.post("ap-workflow/change-status", { status, ids, isForce, tab });
  },
  createBatch: (data: any): Promise<any> => {
    return authBaseAxios.post("ap-workflow/batch", data);
  },
  changeBatchStatus: (batchIds: any[], type: string): Promise<any> => {
    return authBaseAxios.put("ap-workflow/batch-status", { batchIds, type });
  },
  validateCreateBatch: (batchIds: any[]): Promise<any> => {
    return authBaseAxios.post("ap-workflow/validate-create-batch", { batchIds });
  },
};
